import React, { useState, useRef } from 'react';
import { Volume2, VolumeX, Loader2 } from 'lucide-react';
import { withAudioVersion } from '../utils/audioUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AudioPlayer = ({ audioUrl, size = 'md', className = '', onListened }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const audioRef = useRef(null);

  if (!audioUrl) return null;

  const fullUrl = withAudioVersion(audioUrl.startsWith('http') ? audioUrl : `${BACKEND_URL}${audioUrl}`);

  const handlePlay = async () => {
    if (!audioRef.current) return;

    try {
      setIsLoading(true);
      setHasError(false);
      await audioRef.current.play();
      setIsPlaying(true);
    } catch (error) {
      console.error('Audio playback error:', error);
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
    // Signal that audio was listened to completion
    if (onListened) {
      onListened();
    }
  };

  const handleError = () => {
    setHasError(true);
    setIsPlaying(false);
    setIsLoading(false);
  };

  const sizeClasses = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-3'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <>
      <audio
        ref={audioRef}
        src={fullUrl}
        onEnded={handleEnded}
        onError={handleError}
        preload="none"
      />
      <button
        onClick={handlePlay}
        disabled={isLoading || hasError}
        className={`rounded-full transition-all ${sizeClasses[size]} ${
          isPlaying
            ? 'bg-secondary text-white shadow-lg scale-110'
            : hasError
            ? 'bg-stone-300 text-stone-500 cursor-not-allowed'
            : 'bg-secondary/10 text-secondary hover:bg-secondary/20 hover:scale-105'
        } ${className}`}
        title={hasError ? 'Audio non disponible' : 'Écouter'}
      >
        {isLoading ? (
          <Loader2 className={`${iconSizes[size]} animate-spin`} />
        ) : hasError ? (
          <VolumeX className={iconSizes[size]} />
        ) : (
          <Volume2 className={`${iconSizes[size]} ${isPlaying ? 'animate-pulse' : ''}`} />
        )}
      </button>
    </>
  );
};

export default AudioPlayer;
